import {
  useDynamicHeatmapContext,
  useDynamicHeatmapDrawerContext,
} from 'modules/campaignAnalytics/context';
import { forwardRef } from 'react';
import styled from 'styled-components';
import { BUTTON_VARIANTS, GhostLinkButton, IconButton } from 'ui/button';
import { LongArrowLeft24, LongArrowRight24 } from 'ui/icons';
import { body1Bold, body2, colors, duration, easing, fontWeights, spacing } from 'ui/theme';
import { Tooltip } from 'ui/tooltip';
import { pxToRem } from 'utils/convert';
import { ButtonBorder, Details } from './TemplatePreview.styles';

export const Banner = styled.div<{ $isExpanded: boolean }>`
  display: grid;
  grid-template-columns: ${({ $isExpanded }) => ($isExpanded ? '1fr 2fr;' : '1fr')};
  transition: grid-template-columns ${duration.long} ${easing.standard};
`;

export const PreviewDetails = styled.div<{ $isExpanded: boolean }>`
  ${body1Bold};
  padding: ${spacing.half} ${spacing.plusHalf};
  background-color: ${colors.backgroundSecondary};
  border-right: ${spacing.single} solid ${colors.borderPrimary};
  border-bottom: ${spacing.single} solid ${colors.borderPrimary};
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-width: ${pxToRem(400)};
  width: ${({ $isExpanded }) => ($isExpanded ? '100%' : '0px')};
`;

export const UserText = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

export const UserBanner = styled.div`
  text-align: center;
  ${body2};
  padding: ${spacing.half};
  background-color: ${colors.backgroundSecondary};
  border-bottom: ${spacing.single} solid ${colors.borderPrimary};
  color: ${colors.textSecondary};
  display: flex;
`;

export const UserName = styled.span`
  margin-left: ${spacing.quarter};
  font-weight: ${fontWeights.bold};
`;

export const HeaderBanner = forwardRef<HTMLDivElement>((_, ref) => {
  const { isExpanded, toggle, expand, collapse } = useDynamicHeatmapDrawerContext();
  const { isCustomDataCheck, userId } = useDynamicHeatmapContext();
  return (
    <Banner ref={ref} $isExpanded={isExpanded}>
      {isExpanded && (
        <PreviewDetails $isExpanded={isExpanded}>
          Preview details{' '}
          <Tooltip delayDuration={600} tooltipContent={'Hide details'}>
            <IconButton variant={BUTTON_VARIANTS.GHOST} onClick={collapse}>
              <LongArrowLeft24 />
            </IconButton>
          </Tooltip>
        </PreviewDetails>
      )}

      <UserBanner>
        <span>
          {!isExpanded && (
            <Tooltip delayDuration={600} tooltipContent={'View details'}>
              <IconButton variant={BUTTON_VARIANTS.GHOST} onClick={expand}>
                <LongArrowRight24 />
              </IconButton>
            </Tooltip>
          )}
        </span>
        {!isExpanded && <ButtonBorder />}
        <UserText>
          Viewing email as <UserName>{isCustomDataCheck() ? '[ CUSTOM JSON ]' : userId}</UserName>
          <GhostLinkButton data-test="toggle-preview-details-button" onClick={() => toggle()}>
            <Details>{isExpanded ? 'Hide' : 'View'} details</Details>
          </GhostLinkButton>
        </UserText>
      </UserBanner>
    </Banner>
  );
});
